import { render, staticRenderFns } from "./CropTypeModal.vue?vue&type=template&id=c2884988"
import script from "./CropTypeModal.vue?vue&type=script&lang=js"
export * from "./CropTypeModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports